/**
 * Utilidad para generar URLs de imágenes de Unsplash basadas en categorías de comida
 */
import { getUnsplashImageByCategory } from '../services/unsplashService';

/**
 * Mapeo de categorías de ingredientes a términos de búsqueda para Unsplash
 */
const CATEGORY_TO_UNSPLASH_TERM = {
    vegetables: 'vegetable',
    fruits: 'fruit',
    meats: 'meat',
    fish: 'fish',
    dairy: 'dairy',
    legumes: 'legume',
    cereals: 'cereal',
    oils: 'cooking',
    condiments: 'spice',
    other: 'food'
};

/**
 * Genera una URL de Unsplash basada en la categoría
 * @param {string} category - Categoría del ingrediente
 * @returns {string} URL de Unsplash
 */
export const getUnsplashImageUrlSync = (category = 'other') => {
    return getUnsplashImageByCategory(category);
};

/**
 * Determina la categoría principal de una receta basándose en sus ingredientes
 * Prioriza categorías de proteínas (meats, fish) sobre categorías secundarias
 * @param {Array} ingredients - Array de ingredientes con categorías
 * @returns {string} Categoría principal
 */
export const getMainCategory = (ingredients = []) => {
    if (!ingredients || ingredients.length === 0) {
        return 'other';
    }

    // Categorías prioritarias (proteínas principales)
    const PRIORITY_CATEGORIES = ['meats', 'fish'];

    // Categorías secundarias (acompañantes)
    const SECONDARY_CATEGORIES = ['vegetables', 'fruits', 'condiments', 'oils', 'dairy'];

    // Contar ocurrencias de cada categoría
    const categoryCount = {};

    ingredients.forEach(ingredient => {
        const category = ingredient.category || 'other';
        categoryCount[category] = (categoryCount[category] || 0) + 1;
    });

    // Primero, verificar si hay categorías prioritarias (proteínas)
    for (const priorityCategory of PRIORITY_CATEGORIES) {
        if (categoryCount[priorityCategory] && categoryCount[priorityCategory] > 0) {
            return priorityCategory;
        }
    }

    // Si no hay proteínas, buscar la categoría más frecuente entre las no secundarias
    // (evitar que condimentos o aceites sean la categoría principal)
    let mainCategory = 'other';
    let maxCount = 0;

    Object.keys(categoryCount).forEach(category => {
        // Priorizar categorías que no sean secundarias
        const count = categoryCount[category];
        if (count > maxCount && !SECONDARY_CATEGORIES.includes(category)) {
            maxCount = count;
            mainCategory = category;
        }
    });

    // Si no encontramos una categoría principal, usar la más frecuente
    if (mainCategory === 'other' && maxCount === 0) {
        Object.keys(categoryCount).forEach(category => {
            if (categoryCount[category] > maxCount) {
                maxCount = categoryCount[category];
                mainCategory = category;
            }
        });
    }

    return mainCategory;
};

